function collectionLink(AppConfig, CollectionSummaries) {
  switch (AppConfig.status) {
    case 'success':
      break;
    default:
      return '/collection';
  }

  if (AppConfig.data.DisplayPickupRestaurantListScreen) {
    return '/collection';
  }

  if (CollectionSummaries.status !== 'success') {
    return '/collection';
  }

  if (CollectionSummaries.data.length > 0) {
    const summary = CollectionSummaries.data[0];
    return `/restaurant/${summary.VirtualRestaurantId}/collection/${summary.PhysicalRestaurantId}`;
  }

  const [skipRestaurant] = CollectionSummaries.data.filter(
    (collection) => collection.SkipToThisPhysicalRestaurant,
  );

  if (!skipRestaurant) {
    return '/collection';
  }

  return `/restaurant/${skipRestaurant.VirtualRestaurantId}/collection/${skipRestaurant.PhysicalRestaurantId}`;
}

const urlTools = {
  collectionLink,
};

export default urlTools;
